const Theme = {
  mobile: {
    mobileBreakpointWidth: 700,
    tinyMobileBreakpointWidth: 360,
  },
  colors: {
    black: '#333',
    lightBlue: '#e6f4f7',
    selectionBlue: '#ebf5ff',
    green: '#8EC63F',
    gold: '#A08E5C',
    orange: '#fb8e3b',
    red: '#F2434F',
    lightLine: '#e6e6e6',
    line: '#949494',
    divider: '#eee',
    lightBackground: '#f2f2f2',
    mediumBackground: '#ddd',
    lightText: '#999',
    mediumText: '#666',
    darkText: '#333',
    hoverText: '#888',
    lightBorder: '#cccccc',
    inputs: {
      border: '#cecece',
      placeholder: '#757575',
    },
  },
  fontWeight: {
    regular: 300,
  },
};

// Base theme used for partner-branded elements
export const baseTheme = {
  brandColor: Theme.colors.green,
};

export default Theme;
